import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11433db4")

_pushScopeId("data-v-11433db4")
const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body pt-6 pb-0" }
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = { class: "card-title align-items-center" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_6 = { class: "card-label fw-bold fs-3" }
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "row g-5" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "ps-4 pe-4" }
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold text-gray-800" }, "ED PLAN MATCH", -1)
const _hoisted_16 = { class: "text-muted fs-8" }
const _hoisted_17 = { class: "ps-4 pe-4" }
const _hoisted_18 = { class: "fw-semibold text-gray-800" }
const _hoisted_19 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_20 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_21 = { class: "ps-4 pe-4" }
const _hoisted_22 = { class: "fw-semibold text-gray-800" }
const _hoisted_23 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_24 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "ps-4 pe-4" }
const _hoisted_27 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_28 = { class: "d-flex flex-column align-items-center" }
const _hoisted_29 = {
  class: "flex-grow-1 seq-car-fund-chart w-100",
  ref: "carFundChart"
}
const _hoisted_30 = { class: "pt-5 text-center" }
const _hoisted_31 = { class: "seq-badge seq-badge--success" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_DashboardTabNavigator = _resolveComponent("DashboardTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DashboardTabNavigator)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("h3", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
            ]),
            _createVNode("span", _hoisted_6, "Account Info - " + _toDisplayString(_ctx.user.usid), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("table", _hoisted_11, [
                  _createVNode("tbody", null, [
                    (_ctx.pt == 'edp')
                      ? (_openBlock(), _createBlock("tr", _hoisted_12, [
                          _createVNode("td", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("div", null, [
                                _hoisted_15,
                                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.edplanpairs) + " / " + _toDisplayString(_ctx.maxUturn), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summary1, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: 's1-' + index
                      }, [
                        _createVNode("td", _hoisted_17, [
                          _createVNode("div", _hoisted_18, _toDisplayString(item.tdesc.toUpperCase()), 1),
                          (item.vAmt.match('^[1-9]\\d*(\\.\\d+)?$'))
                            ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.numberWithCommas(Number(item.vAmt).toFixed(2))), 1))
                            : (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(item.vAmt), 1))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summary2, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: 's2-' + index
                      }, [
                        _createVNode("td", _hoisted_21, [
                          _createVNode("div", _hoisted_22, _toDisplayString(item.tdesc.toUpperCase()), 1),
                          (item.vAmt.match('^[1-9]\\d*(\\.\\d+)?$'))
                            ? (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(_ctx.numberWithCommas(Number(item.vAmt).toFixed(2))), 1))
                            : (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(item.vAmt), 1))
                        ])
                      ]))
                    }), 128)),
                    (_ctx.isShowMore == true && _ctx.ccode != 15)
                      ? (_openBlock(), _createBlock("tr", _hoisted_25, [
                          _createVNode("td", _hoisted_26, [
                            _createVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-seq-green",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreAccountInfo()))
                            }, " Show More ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            (_ctx.ccode == 0 && _ctx.packageType != 'REGV4Z01')
              ? (_openBlock(), _createBlock("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode(_component_apexchart, {
                        class: "mixed-widget-4-chart",
                        options: _ctx.chartOptions,
                        series: _ctx.series,
                        height: _ctx.chartHeight,
                        type: "radialBar"
                      }, null, 8, ["options", "series", "height"])
                    ], 512)
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("span", _hoisted_31, " You have PhP" + _toDisplayString(_ctx.numberWithCommas(_ctx.carfundMonitor.car_fund.toFixed(2))) + " in your car fund. ", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
})